import React from "react";
import { SearchLoader } from "./S360Loaders";

const SuspensePageLoader: React.FC = () => {
  return (
    <>
      <SearchLoader show />
    </>
  );
};

export default SuspensePageLoader;
